module["exports"] = [
  "Asiatic Lion",
  "Barbary Lion",
  "West African Lion",
  "Northeast Congo Lion",
  "Masai Lion",
  "Transvaal lion",
  "Cape lion"
]


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/animal/lion.js
// module id = 2569
// module chunks = 1610